import script from "./OrderModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./OrderModal.vue?vue&type=script&setup=true&lang=ts"

import "./OrderModal.vue?vue&type=style&index=0&id=450cc8a4&scoped=true&lang=less"

import exportComponent from "/Users/neal/www/bonwey/qingtv-back-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-450cc8a4"]])

export default __exports__